import * as Password from '../constants/Password';
import * as PasswordAPI from '../api/Password';

export function changePassword(
  oldPassword: string, newPassword: string,
  confirmation: string, callBack: Function|undefined) {
  if (newPassword === oldPassword) {
    if (typeof callBack !== 'undefined') {
      callBack(false, 'You typed the same password as your old one');
    }
    return {
      type: Password.DONE_CHANGE_PASSWORD,
      err: 'You typed the same password as your old one',
      result: false,
    };
  } else if (newPassword !== confirmation) {
    if (typeof callBack !== 'undefined') {
      callBack(false, 'You typed inconsistent password in confirmation box');
    }
    return {
      type: Password.DONE_CHANGE_PASSWORD,
      err: 'You typed inconsistent password in confirmation box',
      result: false,
    };
  }

  return PasswordAPI.changePassword(
    oldPassword,
    newPassword,
    () => {
      return {
        type: Password.PROCESS_CHANGE_PASSWORD,
      };
    },
    (result: string, error: string) => {
      if (typeof callBack !== 'undefined') {
        callBack(result, error);
      }

      if (result) {
        return {
          type: Password.DONE_CHANGE_PASSWORD,
          result: result,
        };
      } else {
        return {
          type: Password.DONE_CHANGE_PASSWORD,
          err: error,
          result: result,
        };
      }
    }
  );
}

export function forgotPassword(username: string, callBack: Function|undefined) {
  if (username === '') {
    if (typeof callBack !== 'undefined') {
      callBack(false, 'You should input your username');
    }
    return {
      type: Password.DONE_FORGOT_PASSWORD,
      error: 'You should input your username',
      result: false,
    };
  }

  return PasswordAPI.forgotPassword(
    username,
    () => {
      return {
        type: Password.PROCESS_FORGOT_PASSWORD,
      };
    },
    (result: boolean, error: Error) => {
      if (typeof callBack !== 'undefined') {
        callBack(result, error);
      }

      if (result) {
        return {
          type: Password.DONE_FORGOT_PASSWORD,
          result: result,
        };
      } else {
        return {
          type: Password.DONE_FORGOT_PASSWORD,
          error: error,
          result: result,
        };
      }
    }
  );
}

export function confirmPasswordCode(
  username: string, confirmationCode: string,
  newPassword: string, newPasswordCheck: string, callBack: Function|undefined) {
  if (username === '' || confirmationCode === '' || newPassword === '' || newPasswordCheck === '') {
    if (typeof callBack !== 'undefined') {
      callBack(false, 'You should input your information');
    }
    return {
      type: Password.DONE_FORGOT_PASSWORD,
      error: 'You should input your infomation',
      result: false,
    };
  } else if (newPassword !== newPasswordCheck) {
    if (typeof callBack !== 'undefined') {
      callBack(false, 'You typed the same password as your old one');
    }
    return {
      type: Password.DONE_FORGOT_PASSWORD,
      error: 'You typed the same password as your old one',
      result: false,
    };
  }

  return PasswordAPI.confirmPassword(
    username,
    confirmationCode,
    newPassword,
    () => {
      return {
        type: Password.PROCESS_CONFIRM_PASSWORD,
      };
    },
    (result: boolean, error: Error) => {
      if (typeof callBack !== 'undefined') {
        callBack(result, error);
      }

      if (result) {
        return {
          type: Password.DONE_CONFIRM_PASSWORD,
          result: result,
        };
      } else {
        return {
          type: Password.DONE_CONFIRM_PASSWORD,
          error: error,
          result: result,
        };
      }
    }
  );
}

export function resetStatus() {
  return PasswordAPI.resetStatus(
    () => {
      return {
        type: Password.RESET_STATUS,
      };
    }
  );
}



// WEBPACK FOOTER //
// ./src/actions/Password.tsx